import { render, staticRenderFns } from "./PropertyCalendarWrapper.vue?vue&type=template&id=179190b0&scoped=true&"
import script from "./PropertyCalendarWrapper.vue?vue&type=script&lang=js&"
export * from "./PropertyCalendarWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PropertyCalendarWrapper.vue?vue&type=style&index=0&id=179190b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179190b0",
  null
  
)

export default component.exports